/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobIdentityWithStatus extends models.RecordIdentity {
    getFixupPrototypeFunction() { return BackgroundJobIdentityWithStatus.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobIdentityWithStatus>): BackgroundJobIdentityWithStatus {
        let obj = Object.assign(new BackgroundJobIdentityWithStatus(), model);
        BackgroundJobIdentityWithStatus.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobIdentityWithStatus>): BackgroundJobIdentityWithStatus {
        if (!model) return null;
        return BackgroundJobIdentityWithStatus.newInstance(<BackgroundJobIdentityWithStatus> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobIdentityWithStatus) {
        if (!obj) return;

        models.BackgroundJobIdentityWithStatus.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobIdentityWithStatus): boolean {
        if (models.RecordIdentity.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobIdentityWithStatus.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Status of Background Job
     */
    status: models.BackgroundJobStatus;

}
